import { namespacedConsts } from '../../jsCore/utils/object'

export const JWPLAYER_ACTION_TYPES = namespacedConsts({
  SDK_LOADED: true,
  LOAD_SDK: true,
  ANALYTICS: {
    VIDEO_PLAY: true,
    VIDEO_COMPLETE: true,
    VIDEO_PAUSE: true,
    VIDEO_PERCENTAGE_CHANGE: true,
    VIDEO_EMBED: true,
    FIRSTFRAME: true,
    AD_REQUEST: true,
    AD_IMPRESSION: true,
    AD_BLOCK: true,
    PRO7_EMPATY_TAG: true,
    AD_REQUESTED_PLAY_AD: true,
  },
})

function createSubLabel(position, duration) {
  return `current position=${position}sec; video duration=${duration}sec;`
}

export const loadSdk = _ => ({
  type: JWPLAYER_ACTION_TYPES.LOAD_SDK,
})

export const sdkLoaded = _ => ({
  type: JWPLAYER_ACTION_TYPES.SDK_LOADED,
})

export const jwplayerAnalyticsPlayAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration,
  position
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PLAY,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video play`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
})

export const jwplayerAnalyticsCompleteAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration,
  position
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video complete`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
})

export const jwplayerAnalyticsPauseAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration,
  position
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video paused`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
})

export function jwplayerAnalyticsPercentageChangeAction(
  videoId,
  pageType,
  videoMainWrapperName,
  time,
  percentage
) {
  return {
    type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE,
    state: {
      payload: {
        category: pageType,
        label: videoId,
        action: `jw ${videoMainWrapperName} video ${percentage}% complete`,
        sub_label: createSubLabel(time.position, time.duration),
      },
    },
  }
}

export const jwplayerAnalyticsEmbedAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_EMBED,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video embed`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsAdRequestAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.AD_REQUEST,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video ad request jw ima`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsFirstFrameAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.FIRSTFRAME,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video first frame`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsAdImperssionAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.AD_IMPRESSION,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video ad impression`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsAdBlockAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.AD_BLOCK,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video ad block`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsPro7EmptyTagAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.PRO7_EMPATY_TAG,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} pro7 empty tag`,
      label: videoId,
      sub_label: createSubLabel(duration),
    },
  },
})

export const jwplayerAnalyticsAdRequestedByPlayAdAction = (
  videoId,
  pageType,
  videoMainWrapperName,
  duration
) => {
  return {
    type: JWPLAYER_ACTION_TYPES.ANALYTICS.AD_REQUESTED_PLAY_AD,
    state: {
      payload: {
        category: pageType,
        action: `jw ${videoMainWrapperName} Ad requested play ad`,
        label: videoId,
        sub_label: createSubLabel(duration),
      },
    },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerActions.js